module.exports = __webpack_public_path__ + "img/chevron-up-10012022.82814cf6.svg";